/** @jsx h */
import { h } from 'preact'
import t from '../../../utils/translate'
import ExternalLinkIcon from '../icons/ExternalLinkIcon'

const ReportEvidenceLink = props => {
  const address = 'community@provenance.org'
  const mailSubject = t('feedback.report.mail_subject')
  const mailBody = t('feedback.report.mail_body')

  return (
    <div>
      <p class='CaptionUI--regular u-marginTop16'>
        {t('feedback.report.cta')}
      </p>
      <p class='u-marginTop12'>
        {/* TODO: Use ExternalLink component here */}
        <a
          class='ExternalLink CaptionUI--regular'
          href={`mailto:${address}?subject=${mailSubject}&body=${mailBody}`}
          target='_blank'
          rel='noopener noreferrer'
          onClick={() => {
            props.action()
          }}
        >
          {t('feedback.report.prompt')}
          <ExternalLinkIcon />
        </a>
      </p>
    </div>
  )
}

export default ReportEvidenceLink
